
import Pagination from '../../../../common/components/pagination/index.vue';

export default Pagination;